import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../../providers/config/config.service';
import { SharedDataService } from 'src/providers/shared-data/shared-data.service';


import { ModalController, NavController } from '@ionic/angular';

import { LoadingService } from 'src/providers/loading/loading.service';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { PrivacyPolicyPage } from '../modals/privacy-policy/privacy-policy.page';
import { TermServicesPage } from '../modals/term-services/term-services.page';
import { RefundPolicyPage } from '../modals/refund-policy/refund-policy.page';
import { BranchOfficeModule } from '../branch-office/branch-office.module';
import { BranchOfficePage } from '../branch-office/branch-office.page';

@Component({
  selector: 'app-account-off',
  templateUrl: './account-off.page.html',
  styleUrls: ['./account-off.page.scss'],
})
export class AccountOffPage implements OnInit {

  constructor(
    public shared: SharedDataService,
    public config: ConfigService,
    public modalCtrl: ModalController,
    public loading: LoadingService,
    public iab: InAppBrowser,
    public navCtrl: NavController,

  ) {
  }

  ngOnInit() {
  }

  async showModal(value) {
    if (value == 'privacyPolicy') {
      let modal = await this.modalCtrl.create({
        component: PrivacyPolicyPage
      });
      return await modal.present();
    }
    else if (value == 'termServices') {
      let modal = await this.modalCtrl.create({
        component: TermServicesPage
      });
      return await modal.present();
    }
    else {
      let modal = await this.modalCtrl.create({
        component: RefundPolicyPage
      });
      return await modal.present();
    }
  }
  openSite() {
    this.loading.autoHide(2000);
    this.iab.create(this.config.siteUrl, "blank");
  }
  ionViewWillEnter() {
    if (this.config.admob == 1) this.shared.showAd();
  }

  async openBranch() {
    let modal = await this.modalCtrl.create({
      component: BranchOfficePage
    });
    return await modal.present();

  }

  deletePage() {
    // vamos a enviar la eliminacion de la cuenta
    console.log("Eliminar esta cuenta");

    this.loading.show();


    let dat = { id: this.shared.customerData.customers_id };

    this.config.post_Http('account_off', dat)
      .subscribe(
        (data) => { // Success        
          this.loading.hide();
          console.log(data);

          if (data['estado'] == 'ok') {
            console.log("logOut");

            this.shared.logOut();

            console.log("pop");
            this.navCtrl.pop();
            // this.shared.showAlert('Resultado: ' + data['mensaje']);

          } else {
            this.shared.showAlert('Resultado: ' + data['mensaje']);
          }

        },
        (error) => {
          console.error(error);
        });

  }
}
